export const getWeekInfo = (weekSettings = [], overtime, dayTargetHours) =>
  weekSettings.map((day) => ({
    ...day,
    status: overtime || day.isOpen,
    dayTargetHours: day.isOpen ? day.hours : 0,
    maxHoursPerDay: overtime ? 24 : day.isOpen ? day.hours : 0
  }));
